import React from 'react';

const About = () => (
  <div className="max-w-2xl mx-auto mt-10 p-6 bg-white rounded-lg shadow">
    <h2 className="text-2xl font-bold text-orange-600 mb-4">About Tour Leh Ladkah</h2>
    <p className="text-gray-700 mb-2">
      Tour Leh Ladkah is your trusted travel companion, helping you discover and book the best destinations and packages for your next adventure. Our mission is to make travel planning easy, enjoyable, and inspiring for everyone.
    </p>
    <p className="text-gray-700">
      Whether you’re looking for domestic getaways or international experiences, we curate the best options to suit your needs and budget.
    </p>
  </div>
);

export default About;